import EntityType from '@enums/EntityType';
import isEntityPropertyValue from '@utils/properties/isEntityPropertyValue';
import isEntitySkillLevel from '@utils/skills/isEntitySkillLevel';

export default function buildParentTreeItem({ entity, entities, orderItem }) {
  if (entity.childType === EntityType.PROCESS) {
    return {
      type: EntityType.PROCESS,
      typeId: entity.childId,
    };
  }

  const parentEntity = entities[orderItem.type];

  const parentItem = {
    type: parentEntity.__type,
    typeId: parentEntity.uuid,
  };

  if (orderItem.subType) {
    parentItem.subType = orderItem.subType;
    parentItem.subTypeId = entity.uuid || entity.childId;
  }

  if (isEntitySkillLevel(entity.childType)) {
    parentItem.subTypeId = entity.parentId;
    parentItem.valueId = entity.childId;
  }

  if (isEntityPropertyValue(entity.childType)) {
    parentItem.subTypeId = entity.parentId;
    parentItem.valueId = entity.childId;
  }

  return parentItem;
}
